<lib-support-icon
  (showSupport)="showSupport($event)"
  [chatOpen]="isChatOpen$ | async"
  [isChatContainerOpen]="isChatWindowOpen$ | async"
  [unreadMessagesCount]="unreadMessagesCount$ | async"
  [visualGuideOpen]="isVisualGuideOpen$ | async"
  [visualGuidesCount]="visualGuidesCount$ | async"
></lib-support-icon>
